import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SurfaceCard from "../components/SurfaceCard";

// An unknown /admin/* path should stay inside the panel: the public 404 would
// render the marketing navbar and footer inside the admin shell.
const AdminNotFound = () => (
  <SurfaceCard>
    <Stack alignItems="center" spacing={1.5} sx={{ py: 8 }}>
      <Typography sx={{ fontSize: "1.25rem", fontWeight: 700, color: "#1b2a41" }}>
        That admin page does not exist
      </Typography>
      <Typography sx={{ color: "#7b809a", fontSize: "0.875rem" }}>
        The link may be out of date, or the section may have been renamed.
      </Typography>
      <Button component={Link} to="/admin" variant="contained" sx={{ color: "#fff", mt: 1 }}>
        Back to dashboard
      </Button>
    </Stack>
  </SurfaceCard>
);

export default AdminNotFound;
